import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TransgenderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"transgender"}/>
}
